import React, { useState, useContext, useEffect } from "react";
import "./Addtocart.css";
import { UserContext } from "../../context/UserContext";
import sareeImg from "../../assets/medicinedeliveryimg3.png"; // fallback image
import { Alladdressdetails, MedicalEquipmentOrder } from "../../env/action";
import { useNavigate, useParams } from "react-router-dom";

export default function Addtocart() {
  const navigate = useNavigate();
  const { subservice_id } = useParams();
  const { user, token, selectedCartItems = [], setSelectedCartItems } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [addresses, setAddresses] = useState([]);

  const [selectedAddress, setSelectedAddress] = useState();
  const [isAddingNew, setIsAddingNew] = useState(false);
  const [newAddress, setNewAddress] = useState({
    title: "",
    details: "",
  });

  useEffect(() => {
    const savedCart = localStorage.getItem("equipmentCartItems");
    if (savedCart) {
      setSelectedCartItems(JSON.parse(savedCart));
    }
  }, []);


  const fetchAddressList = () => {
    if (!token) {
      console.warn("No token found — skipping fetchAddressList");
      return;
    }
    setLoading(true);
    Alladdressdetails(token, (res) => {
      if (res?.status === 1 && res?.addresses?.length > 0) {
        setAddresses(res.addresses);
        const defaultAddr = res.addresses.find((addr) => addr.type === "default");
        if (defaultAddr) {
          setSelectedAddress(defaultAddr);
        } else if (res.addresses.length > 0) {
          setSelectedAddress(res.addresses[0]);
        }
      } else {
        console.warn("No addresses found");
        setAddresses([]);
      }
      setLoading(false);
    });
  };

  const handleOpenModal = () => {
    setShowModal(true);
    fetchAddressList();
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setIsAddingNew(false);
  };

  // Save new address
  const handleSaveAddress = () => {
    if (!newAddress.title.trim() || !newAddress.details.trim()) {
      alert("Please enter both title and address details.");
      return;
    }

    const id = newAddress.title.toLowerCase().replace(/\s+/g, "-");
    const newAddr = { id, title: newAddress.title, details: newAddress.details };

    setAddresses((prev) => [...prev, newAddr]);
    setSelectedAddress(id);
    handleCloseModal();
  };

  const handleRemoveItem = (id) => {
    const updatedItems = selectedCartItems.filter((item) => item.id !== id);
    setSelectedCartItems(updatedItems);
  };
  const totalAmount = selectedCartItems.reduce(
    (sum, item) => sum + (item.price || 0) * item.quantity,
    0
  );
  const totalDiscount = selectedCartItems.reduce((sum, item) => sum + (item.discount || 0), 0);
  const finalAmount = totalAmount - totalDiscount;


  const handlePlaceOrder = () => {

    if (!token) {
      alert("Please login before Order.");
      return;
    }
    if (!selectedAddress) {
      alert("Please Select a address");
      return;
    }
    setLoading(true);
    const params = {
      "address_id": selectedAddress ? selectedAddress.address_id : user.address_id,
      "items": selectedCartItems,
      "total_amount": totalAmount,
    }

    MedicalEquipmentOrder(params, token, (res) => {
      setLoading(false);
      if (res) {
        if (res.status === 0) {
          alert("Error", res.message);
        } else {
          alert("Success", res.message);
          navigate(`/vendor/${subservice_id}`);
          setSelectedCartItems([]);
        }
      } else {
        alert("Error", "Unexpected response from server.");
      }
    })
  };

  return (
    <div className="container">
      <div className="cart-container">
        <div className="cart-main">
          <div className="cart-left">
            {/* Delivery Section */}
            <div className="delivery">
              <div className="delivery-left">
                <span>Deliver to:</span>
                {selectedAddress ? (
                  <b>
                    {selectedAddress.name},{" "}
                    {selectedAddress.address}, {selectedAddress.locality},{" "}
                    {selectedAddress.city} - {selectedAddress.pincode},{" "}
                    {selectedAddress.state}
                  </b>
                ) : (
                  <b>Select address</b>
                )}
              </div>
              <button className="change-btn" onClick={handleOpenModal}>
                Change
              </button>
            </div>

            {/* Dynamic Cart Items */}
            {selectedCartItems.length > 0 ? (
              selectedCartItems.map((item) => (
                <div key={item.id} className="cart-item-simple d-flex align-items-center justify-content-between p-3 mb-3 shadow-sm rounded">
                  <div className="d-flex align-items-center" style={{ flex: "1 1 40%" }}>
                    <img
                      src={item.image}
                      alt={item.name}
                      className="rounded me-3"
                      style={{
                        width: "70px",
                        height: "70px",
                        objectFit: "cover",
                        border: "1px solid #eee",
                      }}
                    />
                    <div>
                      <p className="fw-bold mb-1">{item.name}</p>
                      <small className="text-muted">Base Price: ₹{item.price}</small>
                    </div>
                  </div>

                  {/* Quantity */}
                  <div className="text-center" style={{ flex: "1 1 15%" }}>
                    <p className="fw-bold mb-1">Qty</p>
                    <span>{item.quantity || 1}</span>
                  </div>

                  {/* Total Price */}
                  <div className="text-center" style={{ flex: "1 1 20%" }}>
                    <p className="fw-bold mb-1">Total</p>
                    <span>₹{(item.price * (item.quantity || 1)).toFixed(2)}</span>
                  </div>

                  {/* Remove Button */}
                  <div style={{ flex: "1 1 10%" }} className="text-end">
                    <button
                      onClick={() => handleRemoveItem(item.id)}
                      className="btn btn-outline-danger btn-sm"
                    >
                      Remove
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <p style={{ textAlign: "center", marginTop: "20px" }}> Your cart is empty!</p>
            )}

            {/* Place Order (Desktop) */}
            {selectedCartItems.length > 0 && (
              <div className="place-order">
                <button onClick={() => handlePlaceOrder()}>PLACE ORDER</button>
              </div>
            )}
          </div>

          {/* PRICE DETAILS SIDE */}
          {selectedCartItems.length > 0 && (
            <div className="cart-right">
              <div className="price-box">
                <h4>PRICE DETAILS</h4>
                <div className="price-row">
                  <span>Price ({selectedCartItems.length} items)</span>
                  <span>₹{totalAmount}</span>
                </div>
                <div className="price-row">
                  <span>Discount</span>
                  <span className="green">− ₹{totalDiscount}</span>
                </div>
                <hr />
                <div className="price-row total">
                  <strong>Total Amount</strong>
                  <strong>₹{finalAmount}</strong>
                </div>
                <p className="save-text">
                  You will save ₹{totalDiscount} on this order
                </p>
              </div>

              <div className="footer-note">
                <i className="checkmark">✔</i> Safe and Secure Payments. Easy returns. 100% Authentic products.
              </div>

              {/* Place Order (Mobile) */}
              <div className="place-order-2">
                <button onClick={() => handlePlaceOrder()}>PLACE ORDER</button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* 📦 Modal */}
      {showModal && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-scroll">
              {!isAddingNew ? (
                <>
                  <h3>Select Delivery Address</h3>

                  {addresses.length > 0 ? (
                    <div className="address-list">
                      {addresses.map((addr) => (
                        <label
                          key={addr.address_id}
                          className="address-option"
                        >
                          <input
                            type="radio"
                            name="address"
                            value={addr.address_id}
                            checked={
                              selectedAddress?.address_id === addr.address_id
                            }
                            onChange={() => setSelectedAddress(addr)}
                          />
                          <div>
                            <strong>{addr.name}</strong>
                            <p>
                              {addr.address}, {addr.locality}, {addr.city} -{" "}
                              {addr.pincode}, {addr.state}
                            </p>
                          </div>
                        </label>
                      ))}
                    </div>
                  ) : (
                    <p>No addresses found</p>
                  )}

                  <button className="add-new-btn" onClick={() => setIsAddingNew(true)}>
                    + Add New Address
                  </button>

                  <div className="modal-actions">
                    <button className="save-btn" onClick={handleCloseModal}>
                      Save
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <h4>Add New Address</h4>

                  <input
                    type="text"
                    placeholder="Address title (e.g., Home, Work)"
                    className="modal-input"
                    value={newAddress.title}
                    onChange={(e) => setNewAddress({ ...newAddress, title: e.target.value })}
                  />
                  <textarea
                    placeholder="Enter full address details"
                    className="modal-input"
                    rows="3"
                    value={newAddress.details}
                    onChange={(e) => setNewAddress({ ...newAddress, details: e.target.value })}
                  ></textarea>

                  <div className="modal-actions">
                    <button className="save-btn" onClick={handleSaveAddress}>
                      Save Address
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
